<ng-container *ngIf="isDescription; else vddInput">
  <span class="bold">{{ matchedValue?.translationid | translate }}</span>
</ng-container>
<ng-template #vddInput>
  <mat-form-field mat-input-height-large-label>
    <mat-label>{{ matchedValue?.translationid | translate }}</mat-label>
    <input
      data-at-remote-diagnostics-edit-value="text"
      gtm="onTextField"
      gtmAction="Vdd text edit value"
      gtmCategory="diagnosticsPage"
      [gtmOn]="['change', 'focus', 'blur']"
      matInput
      type="text"
      [attr.maxlength]="maxLength"
      [value]="matchedValue?.value"
      (change)="valueChange($event)"
      fieldTextContentTooltip
    />
  </mat-form-field>
</ng-template>
